export type Comma = ',' | ';' | '|' | '\t';

export function detectDelimiter(input: string): Comma {
    const separators = [',', ';', '|', '\t'];
    const idx = separators
        .map((separator) => input.indexOf(separator))
        .reduce((prev, cur) =>
            prev === -1 || (cur !== -1 && cur < prev) ? cur : prev
        );
    return (input[idx] || ',') as Comma;
};